import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { combineLatest } from 'rxjs';
import * as XLSX from 'xlsx';
import * as moment from 'moment';
import axios from 'src/app/Service/axios';
declare let $: any;

import { IranianMobileGenerator } from './mobile-generator';
import { IranianMobileGeneratorPlus } from './mobile-generator-plus';
import { InstagramMobileDatasetEngine } from './mobile-dataset-engine_2';


@Component({

  selector: 'app-taxi-monthly-report-details',

  templateUrl: './taxi-monthly-report-details.component.html',

  styleUrls: ['./taxi-monthly-report-details.component.css']

})

export class TaxiMonthlyReportDetailsComponent implements OnInit {
  lst_Lines: any = [];
  lst_Report: any = [];
  lst_Search: any = [];
  lst_EntryExit: any = [];
  fKmTotal: number = 0;
  fADT: number = 0;
  fHours: number = 0;

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strSDate: new FormControl('', Validators.required),

    strEDate: new FormControl('', Validators.required),

    strUnitID: new FormControl('', Validators.required),

  })

  constructor(
    private _tooltip: NotificationService,
    private FormBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private gurdService: GurdServiceService,
    private _otherService: OtherService,
  ) { }

  ngOnInit(): void {

    combineLatest([this.route.params, this.route.queryParamMap]).subscribe(([params, query]) => {

      this.mdl_Search.patchValue({

        strUnitID: params['id'],

        strSDate: query.get('start'),

        strEDate: query.get('end'),

      });

    });

    this.search_Report();

    // this.mobile_Generator();
    // this.mobileGeneratorPlus();

    // http://localhost:4200/vehicle-management/taxi/monthly-report/359633105742444


  }

  async mobileGeneratorPlus() {

    const engine = new InstagramMobileDatasetEngine({
      username: "alireezajb",
      followers: 19000,
      percent: 30
    });

    const phones = engine.generateAll();

    const worksheetData = phones.map(p => ({ phone: p }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Phones');

    XLSX.writeFile(workbook, 'phones.xlsx');

    console.log('Saved', phones.length, 'numbers to phones.xlsx');

  }

  async mobile_Generator() {

    const engine = new InstagramMobileDatasetEngine({
      username: "alireezajb",
      followers: 190000,
      percent: 1
    });

    // const phones = engine.generateAll();
    // console.log(phones.length);
    // console.log(phones);


    let counter = 0;
    for await (const phone of engine.stream()) {
      // console.log(phone);
      console.log(counter + 1 + ':' + phone)
      // if (phone == '09011906744')
      // console.log(counter + 1 + ':' + phone)
      // else
      // console.log(counter)
      counter++;
    }

    console.log('done!')

    return;

    const generator = new IranianMobileGenerator(100_000);

    const mobile1 = generator.next();

    const mobile2 = generator.next();

    const mobile3 = generator.next();

    console.log(mobile1, mobile2, mobile3);

    /-------------------------------------------------/

    const gen = new IranianMobileGeneratorPlus({ seed: 0 });

    let count = 0;

    for await (const num of gen.stream()) {

      console.log(count + 1 + `: ` + num);
      count++;

      if (count >= 27000) break;

    }


  }

  async search_Report() {

    if (this.mdl_Search.invalid) return this._tooltip.showError('تاریخ شروع و پایان را وارد کنید')

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Taxi_DriverFleetPerformanceReport`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Report = res;

    this.lst_Search = res;

    this.fKmTotal = 0;

    this.fADT = 0;

    this.fHours = 0;

    this.lst_Report.forEach((el: any) => {

      this.fKmTotal += el.fKmTotal;

      this.fADT += el.fADT;

      this.fHours += el.fHours;

    })

    this.fADT = this.fADT / this.lst_Report.length;

  }

  highlightText(text: string, searchTerm: string) {

    if (!searchTerm) {

      return text;

    }

    const regex = new RegExp(searchTerm, 'gi');

    return text?.replace(regex, (match: string) => {

      return `<mark>${match}</mark>`;

    });

  }

  filter_list(val: any) {

    this.lst_Report = this.lst_Search.filter((el: any) => {

      return el?.strBusLineName?.toString().startsWith(val.value) ||

        el.strFullName?.toString().startsWith(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Report = this.lst_Search;

    }

  }

  exportExcel(id: any): void {

    if (!this.lst_Report.length) return;

    let element = document.getElementById(`${id}`);

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, `جزئیات عملکرد ماهیانه-${this.lst_Report[0]?.strFullName}.xlsx`);

  }

  sortfKmTotal() {

    if (this.lst_Report.length < 2) return;

    const isAsc = Number(this.lst_Report[0].fKmTotal) <= Number(this.lst_Report[this.lst_Report.length - 1].fKmTotal);

    this.lst_Report.sort((a: any, b: any) => {

      const aVal = Number(a.fKmTotal);

      const bVal = Number(b.fKmTotal);

      return isAsc ? bVal - aVal : aVal - bVal;

    });

  }

  sortfADT() {

    if (this.lst_Report.length < 2) return;

    const isAsc = Number(this.lst_Report[0].fADT) <= Number(this.lst_Report[this.lst_Report.length - 1].fADT);

    this.lst_Report.sort((a: any, b: any) => {

      const aVal = Number(a.fADT);

      const bVal = Number(b.fADT);

      return isAsc ? bVal - aVal : aVal - bVal;

    });

  }

  openDetails(item) {

    const res = JSON.parse(item.strEntryExit.toString());

    res.forEach((el: any) => {

      const startTime = moment(el.entry, 'HH:mm:ss');

      const endTime = moment(el.exit, 'HH:mm:ss');

      const duration = moment.duration(endTime.diff(startTime));

      const hours = Math.floor(duration.asHours()).toString().padStart(2, '0');

      const minutes = duration.minutes().toString().padStart(2, '0');

      const seconds = duration.seconds().toString().padStart(2, '0');

      el.duration = `${hours}:${minutes}:${seconds}`;


    });

    this.lst_EntryExit = res;

    $("#viewModal").modal("show");


  }



}
